"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconDelivery = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconDelivery = function IconDelivery(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.328 4a1 1 0 0 1 .969 1.246L18.105 6h1.244a2 2 0 0 1 1.92 1.441l1.154 3.96c.12.167.19.374.19.599v4c0 .552-.426 1-.952 1h-1.09l-.003.02a3 3 0 0 1-5.874.175l-.04-.194h-4.083l-.003.02a3 3 0 0 1-5.874.174L4.654 17 3.566 17c-.526 0-.952-.448-.952-1v-4c0-.075.008-.149.023-.22l.2-.78h.98l-.25 1v4h1.088l.004-.02a3 3 0 0 1 5.874-.175l.04.195h3.954l2.802-11H5.39l-.127.5H4.233l.189-.746A1 1 0 0 1 5.39 4h11.937zM7.613 14.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm10 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm4.048-2.5h-5.078l-.493 1.915a3.001 3.001 0 0 1 4.442 1.89l.04.195h1.089v-4zm-2.312-5h-1.497l-1.007 4h4.42l-.956-3.28a1 1 0 0 0-.84-.713L19.349 7zm-8.952 2-.333 1H0l.333-1h10.064zm.828-2.5-.333 1H1l.333-1h9.892z"
  }));
};
exports.IconDelivery = IconDelivery;